import { useState, type PropsWithChildren } from "react";

import { TimeSpanInputContext } from "@/contexts/TimeSpanInputContext";

export function TimeSpanInputProvider({ children }: PropsWithChildren) {
  const state = useState<Date | null>(null); // oxlint-disable-line hook-use-state
  return <TimeSpanInputContext.Provider value={state}>{children}</TimeSpanInputContext.Provider>;
}
